import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

function parseJwt(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

function tokenExpire(token) {
  const payload = parseJwt(token);
  if (!payload?.exp) return true;
  return payload.exp * 1000 < Date.now();
}

export function AuthProvider({ children }) {
  const [utilisateur, setUtilisateur] = useState(null);
  const [token, setToken] = useState(null);
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    const tokenStocke = localStorage.getItem('token');
    if (tokenStocke) {
      if (tokenExpire(tokenStocke)) {
        localStorage.removeItem('token');
        localStorage.removeItem('utilisateur');
      } else {
        try {
          setToken(tokenStocke);
          setUtilisateur(JSON.parse(localStorage.getItem('utilisateur')));
        } catch {
          localStorage.removeItem('token');
          localStorage.removeItem('utilisateur');
        }
      }
    }
    setChargement(false);
  }, []);

  const connecter = (nouveauToken, nouvelUtilisateur) => {
    localStorage.setItem('token', nouveauToken);
    localStorage.setItem('utilisateur', JSON.stringify(nouvelUtilisateur));
    setToken(nouveauToken);
    setUtilisateur(nouvelUtilisateur);
  };

  const deconnecter = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('utilisateur');
    setToken(null);
    setUtilisateur(null);
  };

  return (
    <AuthContext.Provider
      value={{
        utilisateur,
        token,
        estConnecte: !!token,
        chargement,
        connecter,
        deconnecter,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
